import { ModalCustom } from "components/ModalCustom";
import { FaCheck } from "react-icons/fa";
import { Icone, ModalBody } from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
}

export function ModalSucessoReprovarLote({ show, handleClose }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Reprovar lote"
      centered
    >
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        Lote reprovado com sucesso!
      </ModalBody>
    </ModalCustom>
  );
}
